
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M8 0C3.584 0 0 3.584 0 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M7.98 7.664a.857.857 0 01.855.86l-.01 3.205a.857.857 0 01-1.714-.006l.01-3.205a.857.857 0 01.86-.854zm-.012-3.767a1.143 1.143 0 110 2.286 1.143 1.143 0 010-2.286z","fill":"#FFF"}})])])
          )
        }
      }
    